import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';

/**
 * Transforms MarketplaceFormData to Partial<MarketplaceRequest>
 * @param marketplaceFormData
 */
export const getMarketplaceBaseDetailsRequest = (
  marketplaceFormData: MarketplaceFormData,
): Pick<
  MarketplaceRequest,
  | 'marketplaceType'
  | 'ticketLimit'
  | 'capacityDefaultString'
  | 'rules'
  | 'lowCapacityPercentageThreshold'
> => {
  const {
    type,
    ticketLimit,
    capacity,
    rules,
    lowCapacityPercentageThreshold,
  } = marketplaceFormData;

  return {
    marketplaceType: type,
    ticketLimit,
    rules: rules[0].value,
    capacityDefaultString: capacity[0].value,
    lowCapacityPercentageThreshold,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/marketplace-request/marketplace-base-details-request.helper.ts